












































import { Component, Vue } from 'vue-property-decorator';
import { Employee, LoginRequired, TooManyRequests, employeeApis } from './api';
import { Route } from 'vue-router';
declare const EMPLOYEE: Employee;

@Component({
  errorCaptured: function(err, vm, info) {
    if (err instanceof LoginRequired) {
      this.$store.commit('perms/update', []);
      this.$store.commit('employee/update', null);
      this.$router.push({ name: 'Login', query: { redirect: this.$route.fullPath } });
    } else if (err instanceof TooManyRequests) {
      this.$notify.error({ title: '错误', message: `请求过于频繁，请稍后再试`, duration: 3000 });
    } else {
      console.log('error captured', err, vm, info);
      this.$notify.error({ title: '错误', message: err.message, duration: 3000 });
    }
  },
  computed: {
    employee() {
      return this.$store.state.employee.employee;
    }
  }
})
export default class AppPc extends Vue {
  background_color = '#b92929';
  enterRouter?: Route = undefined;

  hasPerm(name: string) {
    return this.$store.getters['perms/has'](name);
  }

  mounted() {
    // 使用当前真实路径解析路由配置
    const currentPath = window.location.pathname;
    const resolvedRoute = this.$router.resolve(currentPath);
    this.enterRouter = resolvedRoute ? resolvedRoute.route : this.$route;

    if (this.loginRequired) {
      if (!EMPLOYEE && currentPath != '/login' && currentPath != '/login/passwd') {
        this.$router.push({ name: 'Login', query: { redirect: window.location.pathname + window.location.search } });
      }
    }
  }

  get defaultActive() {
    const parts = this.$route.path.split('/');
    if (parts.length >= 2) {
      return `/${parts[1]}`;
    } else {
      return '/';
    }
  }

  get showMenu() {
    return !this.enterRouter?.meta.hideMenu;
  }

  get loginRequired() {
    return this.enterRouter?.meta.loginRequired !== false;
  }

  navSelect(index: string) {
    if (index.startsWith('/') && this.$route.path != index) {
      this.$router.push(index);
    }
  }

  async logout() {
    await employeeApis.logout();
    location.reload();
  }

  get_now_env() {
    const reg = /employee\.(.*)\.91jkys\.com$/;
    const result = location.hostname.match(reg);
    if (result) {
      if (result[1] === 'qa') {
        this.background_color = '#078852';
      } else {
        this.background_color = '#cc7720';
      }
      return result[1] + '环境';
    } else {
      this.background_color = '#b92929';
    }
    return '线上环境';
  }

  async change_env(env: string) {
    if (env == 'qa') {
      window.open(process.env.VUE_APP_QA_EMPLOYEE_ADDRESS);
    } else {
      window.open(process.env.VUE_APP_EMPLOYEE_ADDRESS);
    }
  }
}
